"use client";

import dynamic from "next/dynamic";
import { useEffect, useState } from "react";

import ImpersonationBar from "@/components/impersonation-bar";
import Spinner from "@/components/spinner";

import useSession from "@/hooks/use-session";

import { useGlobalState } from "@/providers/global-provider";

const BeforeInstallPrompt = dynamic(() => import("@/components/before-install-prompt"));
const FastOrderDialog = dynamic(() => import("@/components/fast-order/fast-order-dialog"), {
  loading: () => (
    <div className="fixed inset-0 z-[100] flex w-screen flex-col items-center justify-center overflow-y-auto bg-zinc-950/25 focus:outline-0 sm:px-6 sm:py-8 lg:px-8 lg:py-16 dark:bg-zinc-950/50">
      <Spinner className="size-6 text-white" />
    </div>
  ),
});

export default function RootTemplate({ children }: { children: React.ReactNode }) {
  const { session } = useSession();
  const [beforeInstallPromptShow, setBeforeInstallPromptShow] = useState<boolean>(false);
  const { fastOrderDialogOpen, setFastOrderDialogOpen } = useGlobalState();

  useEffect(() => {
    if (typeof window !== "undefined" && "serviceWorker" in navigator) {
      const installationPrompt = localStorage.getItem("installationPrompt");
      if (
        installationPrompt !== "shown" &&
        /iPad|iPhone|iPod/.test(navigator.userAgent) &&
        "standalone" in window.navigator &&
        !window.navigator.standalone
      ) {
        setBeforeInstallPromptShow(true);
      }
    }
  }, []);

  return (
    <>
      {session?.isLoggedIn && session?.isImpersonated && (
        <ImpersonationBar fullName={session?.fullName} />
      )}
      {/* {beforeInstallPromptShow && (
        <BeforeInstallPrompt
          onClose={() => {
            localStorage.setItem("installationPrompt", "shown");
            setBeforeInstallPromptShow(false);
          }}
        />
      )} */}

      {fastOrderDialogOpen && (
        <FastOrderDialog open={fastOrderDialogOpen} onOpenChange={setFastOrderDialogOpen} />
      )}

      {children}
    </>
  );
}
